<!--搜索条件配置按钮-->
<template>
  <div class="cond-cfg-drawer">
    <el-tooltip
      content="筛选配置"
      placement="bottom"
      :fallback-placements="['top', 'bottom']"
    >
      <el-button
        :icon="Icons.easySearchSetting"
        class="setting-btn"
        @click="openConfig"
      />
    </el-tooltip>
  </div>
</template>

<script setup lang="ts">
import { useShareData } from '../../core/SharedData';
import { Icons } from '../../common/Icons';
import { showDrawer } from '../../core/EasyPopup';
import SearchConditionDrawer from './SearchConditionDrawer.vue';

const layout = useShareData('search', 'layout');

const emit = defineEmits(['fieldChange']);

function openConfig() {
  return showDrawer(
    SearchConditionDrawer,
    { layout: () => layout },
    {
      title: '筛选配置',
      modal: true,
      closeOnClickModal: true,
      callback: () => {
        emit('fieldChange');
      }
    }
  );
}
</script>

<style lang="scss" scoped>
.cond-cfg-drawer {
  display: inline;
}

.setting-btn {
  width: 34px;
  height: 34px;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
}
</style>
